module.exports = __webpack_public_path__ + "img/imlogo.4103e261.png";